<template>
  <div class="layout-menu-container">
    <AppSubmenu
      :items="items"
      class="layout-menu"
      :root="true"
      @menuitem-click="onMenuItemClick"
    />
    <AppVetMenu v-if="$ability.can('manage', 'VetCustomer')"> </AppVetMenu>
  </div>
</template>

<script>
import AppSubmenu from './AppSubmenu';
import AppVetMenu from './AppVetMenu.vue';
import { mapGetters } from 'vuex';

export default {
  methods: {
    onMenuItemClick(event) {
      this.$emit('menuitem-click', event);
    },
  },
  components: {
    AppSubmenu,
    AppVetMenu,
  },
  computed: {
    ...mapGetters('app', ['vetCustomer']),
    items() {
      const manageApp = this.$ability.can('manage', 'App');
      const manageAdmin = this.$ability.can('manage', 'Admin');
      return [
        {
          label: 'Home',
          icon: 'app-icon app-icon-home',
          to: 'home',
          visible:
            manageApp &&
            this.$ability.can('read', 'Home') &&
            !this.$ability.can('manage', 'VetCustomer'),
        },
        {
          label: 'Bovinos',
          icon: 'app-icon app-icon-bovine',
          to: 'bovine.list',
          visible:
            manageApp &&
            this.$ability.can('read', 'Bovine') &&
            !this.vetCustomer,
        },
        {
          label: 'Lotes/Piquetes',
          icon: 'app-icon app-icon-place',
          to: 'lot.list',
          visible: manageApp && this.$ability.can('read', 'FarmLot'),
        },
        {
          label: 'Fazendas',
          icon: 'app-icon app-icon-map',
          to: 'farm.list',
          visible: manageApp && this.$ability.can('read', 'Farm'),
        },
        {
          label: 'Serviços',
          icon: 'app-icon app-icon-service',
          to: 'service.list',
          visible: manageApp && this.$ability.can('read', 'Service'),
        },
        {
          label: 'Vendas',
          icon: 'app-icon app-icon-cart',
          to: 'sale.list',
          visible: manageApp && this.$ability.can('read', 'Sale'),
        },
        {
          label: 'Caixa',
          icon: 'app-icon mi mi-attach-money',
          to: 'cashflow.list',
          visible: manageApp && this.$ability.can('read', 'CashFlow'),
        },
        {
          label: 'Clientes',
          icon: 'app-icon app-icon-person blue',
          to: 'vet-customer.list',
          visible: manageApp && this.$ability.can('manage', 'VetCustomer'),
        },
        {
          label: 'Outros',
          icon: 'app-icon app-icon-edit',
          items: [
            {
              label: 'Veterinários',
              to: 'vet.list',
              visible: manageApp && this.$ability.can('manage', 'Vet'),
            },
            {
              label: 'Proprietários',
              to: 'owner.list',
              visible: manageApp && this.$ability.can('read', 'Owner'),
            },
            {
              label: 'Usuários',
              to: 'user.list',
              visible: manageAdmin || (manageApp && this.$ability.can('read', 'User')),
            },
            {
              label: 'Faturas',
              to: 'invoice.list',
              visible: manageApp && this.$ability.can('read', 'Invoice'),
            },
            {
              label: 'Modelos de Relatórios',
              to: 'report-template.list',
              visible: manageApp,
            },
            {
              label: 'Contas',
              to: 'account.list',
              visible: manageAdmin,
            },
          ],
        },
      ];
    },
  },
};
</script>

<style scoped>
</style>
